export const SET_ITEM_ADDED_TO_CART = 'SET_ITEM_ADDED_TO_CART';
export const SET_IS_WIDGET_SHOWN = 'SET_IS_WIDGET_SHOWN';
export const SET_FASLET_SHOPPING_ID = 'SET_FASLET_SHOPPING_ID';
export const SET_FASLET_ORDER_TRACKING_DATA = 'SET_FASLET_ORDER_TRACKING_DATA';
export const SET_INITIAL_ORDER_TRACKING_DATA = 'SET_INITIAL_ORDER_TRACKING_DATA';
export const SET_FASLET_ANALYTIC_TRIGGER = 'SET_FASLET_ANALYTIC_TRIGGER';
